import AdminStaffContent from "../../../components/Admin/Staff"

const AdminStaff = () => {

    return (
        <>
            <AdminStaffContent />
        </>
    )

}

export default AdminStaff